import React from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../common/GridLayout";

import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    Export,
    ColumnHeaderFilter,
    ColumnChooser,
    ColumnChooserSearch,
    HeaderFilter,
    ColumnFixing,
    Scrolling,
    StateStoring,
} from "devextreme-react/data-grid";
let detailInDataGrid = React.createRef();
let accessToken = '';
const gridKey = "b1fde378-f038-46ce-896e-47deb5a6548b";
const statusLookup = [
    { ID: 'O', Text: "Open" },
    { ID: 'H', Text: "Hold" },
    { ID: 'L', Text: "Ready To Commit Later" },
    { ID: 'N', Text: "Ready To Commit Now" },
];
const toStage = [
    { ID: 'L', Text: 'Canceled - No Inventory Effect' },
    { ID: 'Q', Text: 'Quote - No Inventory Effect' },
    { ID: 'P', Text: 'Plan - No Inventory Effect' },
    { ID: 'F', Text: 'Future - No Effect on Net Available' },
    { ID: 'N', Text: 'Pending - Effects Net Available' },
    { ID: 'A', Text: 'Assigned - Effects Available' },
    { ID: 'S', Text: 'Picked/Staged - Effects Available' },
    { ID: 'C', Text: 'Shipped/Completed - Effects Available' }
];
class TransferDeliveryToDispatchPreview extends React.Component {

    constructor(props) {
        super(props);
        accessToken = props.oidc.user.access_token;

        this.state = {
            records: 0
        }
        this.loadState = this.loadState.bind(this);
        this.saveState = this.saveState.bind(this);
    }

    loadState() {
        // const { gridKey, accessToken } = this.state;
        return GridLayout.sendStorageRequest(gridKey, "GET", accessToken);
    }

    saveState(state) {
        GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state);
    }
    render() {
        return (
            <div className="row" style={{ height: '100%', width: '100%' }}>
                <DataGrid

                    onExporting={(e) => {
                        if (window.handleDevExtremeDataGridExport) {
                            window.handleDevExtremeDataGridExport(e);
                        }
                    }}
                    dataSource={this.props.dataSource}
                    showBorders={true}
                    ref={detailInDataGrid}
                    className="customDataTableDesignCommit"
                    hoverStateEnabled={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    columnAutoWidth={true}
                    showRowLines={true}
                    style={{ height: '100%', width: '100%' }}
                //onContentReady={this.DetailInGridContentReady}
                >
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <ColumnFixing enabled={true} />
                    <ColumnHeaderFilter />
                    <Export enabled={true} allowExportSelectedData={true} text="Export" />
                    <Sorting visible={true} mode="multiple" />
                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={10} />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                        showNavigationButtons={true}
                    />
                    <FilterRow visible={true} />
                    <FilterPanel visible={true} />
                    <HeaderFilter />
                    <GroupPanel visible={true} />
                    <Grouping autoExpandAll={false} />
                    <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={this.loadState}
                        storageKey={gridKey}
                        customSave={this.saveState}
                    />
                    <Column
                        dataField="RecordNo"
                        caption="Record #"
                        allowEditing={false}
                    ></Column>

                    <Column
                        dataField="CustomerID"
                        caption="Customer"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="Transactionnumber"
                        caption="Transaction #"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="Transactiondate"
                        caption="Transaction Date"
                        dataType="datetime"
                        format="MM/dd/yyyy hh:mm:ss a"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="ShipToID"
                        caption="Ship To"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="ShipToState"
                        caption="Ship To State"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="ShipToZip"
                        caption="Ship To Zip"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="ShipViaID"
                        caption="Ship Via"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="Shippingdate"
                        caption="Shipping Date"
                        dataType="datetime"
                        format="MM/dd/yyyy hh:mm:ss a"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="Purchaseordernumber"
                        caption="PO Number"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="Reference"
                        caption="Reference"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="Truckreference"
                        caption="Truck Reference"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="Canceldate"
                        caption="Cancel Date"
                        dataType="datetime"
                        format="MM/dd/yyyy hh:mm:ss a"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="Partialshipment"
                        caption="Partial Shipment"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="Reasoncode"
                        caption="Reason Code"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="Fmtripnumber"
                        caption="FM Trip Number"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="Status"
                        caption="Status"
                        allowEditing={false}
                        visible={true}
                        lookup={{ dataSource: statusLookup, valueExpr: 'ID', displayExpr: 'Text' }}
                        cellRender={cellData => {
                            switch (cellData.value) {
                                case 'O':
                                    return <span >Open</span>;
                                case 'H':
                                    return <span >Hold</span>;
                                case 'L':
                                    return <span >Ready To Commit Later</span>;
                                case 'N':
                                    return <span >Ready To Commit Now</span>;
                                default:
                                    return <span>{cellData.value}</span>;
                            }
                        }}
                    ></Column>
                    <Column
                        dataField="Stage"
                        caption="Stage"
                        allowEditing={false}
                        visible={true}
                        lookup={{ dataSource: toStage, valueExpr: 'ID', displayExpr: 'Text' }}
                        cellRender={cellData => {
                            switch (cellData.value) {
                                case 'L':
                                    return <span >Canceled - No Inventory Effect</span>;
                                case 'Q':
                                    return <span >Quote - No Inventory Effect</span>;
                                case 'P':
                                    return <span >Plan - No Inventory Effect</span>;
                                case 'F':
                                    return <span >Future - No Effect on Net Available</span>;
                                case 'N':
                                    return <span >Pending - Effects Net Available</span>;
                                case 'S':
                                    return <span >Picked/Staged - Effects Available</span>;
                                case 'C':
                                    return <span >Shipped/Completed - Effects Available</span>;
                                case 'A':
                                    return <span >Assigned - Effects Available</span>;

                                default:
                                    return <span>{cellData.value}</span>;
                            }
                        }}
                    ></Column>
                    <Column
                        dataField="Backorderflag"
                        caption="Backorder Flag"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="ProfileCode"
                        caption="Profile Code"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="CustomerCode1"
                        caption="Code 1"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="CustomerCode2"
                        caption="Code 2"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="CustomerCode3"
                        caption="Code 3"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="CustomerCode4"
                        caption="Code 4"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="CustomerCode5"
                        caption="Code 5"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="CustomerCode6"
                        caption="Code 6"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="CustomerCode7"
                        caption="Code 7"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="CustomerCode8"
                        caption="Code 8"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="CustomerCode9"
                        caption="Code 9"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="CustomerCode10"
                        caption="Code 10"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="Chargeandholdtype"
                        caption="Charge and Hold Type"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="CustomerIDGroup"
                        caption="Customer ID Group"
                        allowEditing={false}
                        visible={true}
                    ></Column>
                    <Column
                        dataField="CustomerIDSubgroup"
                        caption="Customer ID Subgroup"
                        allowEditing={false}
                        visible={true}
                    ></Column>

                </DataGrid>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(TransferDeliveryToDispatchPreview);